var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tableComponent',{ref:"tableComponent",staticClass:"pa-5 pl-0",attrs:{"tableSettings":_vm.tableSettings,"tableData":_vm.tableData,"headers":_vm.headers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }